import { connect } from 'react-redux';
import HazardReviewPanel from '../../components/HazardReviewPanel';
import { submitMode } from '../../constants';
import { domainType } from '../../constants';

import {
  handleHazardInputChangeDispatch,
  submitHazardDispatch,
  handleDeleteHazardReviewClickDispatch,
  submitHazardReviewDispatch,
  enableEditHazardReviewDispatch,
  handleEditHazardReviewInputChangeDispatch,
  handleAddHazardReviewInputChangeDispatch,
  openAddHazardReviewDialogDispatch,
  openHazardReviewPanelDispatch,
  fetchReviewsForTheHazardDispatch,
  openDeleteHazardReviewDialogDispatch,
  removeHazardReviewAttachmentEdit,
  fetchExistingAttachmentsForHazardReviewDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    openPanel: state.hazard.newHazard.showEditHazardPanel,
    hazard: state.hazard.newHazard.item,
    branchId: state.branch.branch.item && state.branch.branch.item.id,
    reviews: state.hazard.reviewsForTheHazard.items,
    review: state.hazard.newReview.item,
    isEditReviewEnabled: state.hazard.editReview.enable,
    reviewBeingEdited: state.hazard.editReview.item,
    openAddHazardReviewDialog: state.hazard.newReview.openAddHazardReviewDialog,
    openHazardReviewPanel: state.hazard.newHazard.showHazardReviewPanel,
    openDeleteReviewDialog:
      state.hazard.toBeDeleteReview.showDeleteHazardReviewDialog,
    showDeleteReviewDialog:
      state.hazard.toBeDeleteReview.showDeleteHazardReviewDialog,
    userId: state.users.user.item,
    allAttachments:
      state.hazard.editReview.item &&
      state.hazard.editReview.item.attachmentFiles
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    openHazardReviewPanel: (open) => {
      dispatch(openHazardReviewPanelDispatch(open));
    },
    onHandleInputChange: (value, inputFieldName) => {
      dispatch(handleHazardInputChangeDispatch(value, inputFieldName));
    },
    submitHazard: (hazard) => {
      const mode = submitMode.UPDATE;
      dispatch(submitHazardDispatch(hazard, mode));
    },
    fetchReviewsForTheHazard: (hazardId) => {
      dispatch(fetchReviewsForTheHazardDispatch(hazardId));
    },
    onHandleDeleteHazardReviewClick: (payload) => {
      dispatch(handleDeleteHazardReviewClickDispatch(payload));
    },
    submitReview: (payload, mode, branchId) => {
      dispatch(submitHazardReviewDispatch(payload, mode, branchId));
    },
    enableEditHazardReview: (
      enableEditControlMode,
      parentId,
      loggedInUserId
    ) => {
      dispatch(enableEditHazardReviewDispatch(enableEditControlMode, parentId));
      dispatch(
        fetchExistingAttachmentsForHazardReviewDispatch(
          domainType.HAZARD_REVIEW,
          parentId,
          loggedInUserId
        )
      );
    },
    onRemoveAttachment: (attachment) => {
      dispatch(removeHazardReviewAttachmentEdit(attachment));
    },
    onHandleAddHazardReviewInputChange: (value, inputFieldName) => {
      dispatch(handleAddHazardReviewInputChangeDispatch(value, inputFieldName));
    },
    onHandleEditHazardReviewInputChange: (value, inputFieldName) => {
      dispatch(
        handleEditHazardReviewInputChangeDispatch(value, inputFieldName)
      );
    },
    onOpenAddHazardReviewDialog: (open) => {
      dispatch(openAddHazardReviewDialogDispatch(open));
    },
    onOpenDeleteHazardReviewDialog: (open, reviewId) => {
      dispatch(openDeleteHazardReviewDialogDispatch(open, reviewId));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HazardReviewPanel);
